import { render, staticRenderFns } from "./user_profiler.vue?vue&type=template&id=096af07c&scoped=true&"
import script from "./user_profiler.vue?vue&type=script&lang=js&"
export * from "./user_profiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096af07c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('096af07c')) {
      api.createRecord('096af07c', component.options)
    } else {
      api.reload('096af07c', component.options)
    }
    module.hot.accept("./user_profiler.vue?vue&type=template&id=096af07c&scoped=true&", function () {
      api.rerender('096af07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/user/small_block/user_profiler.vue"
export default component.exports